import { ACTION_TYPES } from '../utils/Constants';

let initialState = {
    whiteBoardDrawList: [],
    isWhiteboardOpen: false,
    sessionType: '',
    currentVisitId: null,
    senderUserId: null,
};

const WhiteBoardReducerList = (state = initialState, action = {}) => {
    switch (action.type) {
        case ACTION_TYPES.WHITE_BOARD_DRAW:
            return {
                ...state,
                whiteBoardDrawList: [action.payload.whiteBoardDrawList],
                currentVisitId: action.payload.visitId,
                senderUserId: action.payload.senderUserId,
            };

        case ACTION_TYPES.WHITE_BOARD_OPEN:
            return {
                ...state,
                isWhiteboardOpen: action.payload.isWhiteboardOpen,
                sessionType: action.payload.sessionType,
            };
        default:
            return state;
    }
};

export default WhiteBoardReducerList;
